export default "__VITE_ASSET__HnN5wZFC__"